import { render } from "./employee-list.vue?vue&type=template&id=20d67ad1&scoped=true"
import script from "./employee-list.vue?vue&type=script&lang=js"
export * from "./employee-list.vue?vue&type=script&lang=js"

import "./employee-list.vue?vue&type=style&index=0&id=20d67ad1&scoped=true&lang=css"
import "./employee-list.vue?vue&type=style&index=1&id=20d67ad1&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d67ad1"]])

export default __exports__